export default __webpack_public_path__ + "static/media/stakes.496971e1.png";